<template>
    <div class="waterfall-box">
        <template
            v-for="(item, index) in list"
            v-if="index < coords.length"
        >
            <div @click="onChange(item)">
                <WaterfallItem
                    :item="item"
                    :coords="coords[index]"
                    :selected="selected"
                    :index="index"
                    @mounted="childNodeRendered"
                    @change="onChange"
                />
            </div>
        </template>
    </div>
</template>

<script>
import WaterfallItem from './waterfall-item';
import { replyImgTxtType } from '../config/index';

const rowGap = 30;
const columnGap = 30;
const waterfallItemWidth = 319;

export default {
    name: 'WaterfallPicker',
    components: {
        WaterfallItem,
    },
    props: {
        list: {
            type: Array,
        },
        selected: {
            type: Object,
        },
    },
    data() {
        return {
            columns: [],
            coords: [],
            rowStart: 0,
        };
    },
    watch: {
        list() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        childNodeRendered({ node, coords }) {
            const { colIndex } = coords;
            this.columns[colIndex] += node.offsetHeight + columnGap;

            const minHeight = Math.min.apply(Math, this.columns);
            const minIndex = this.columns.indexOf(minHeight);
            const temp = {
                x: this.rowStart + (waterfallItemWidth + rowGap) * minIndex,
                y: minHeight,
                colIndex: minIndex,
            };
            this.coords.push(temp);
        },
        onChange(item) {
            this.$emit('change', { replyType: replyImgTxtType, ...item });
        },
        init() {
            const boxWidth = this.$el.offsetWidth;
            const count = Math.floor(boxWidth / (waterfallItemWidth + rowGap));
            this.rowStart = (boxWidth - (waterfallItemWidth + rowGap) * count + rowGap) / 2;
            this.columns = new Array(count).fill(0);

            this.coords = [
                {
                    x: this.rowStart,
                    y: 0,
                    colIndex: 0,
                },
            ];
        },
    },
};
</script>

<style>
.waterfall-box {
    position: relative;
    height: 100%;
    overflow: auto;
    text-align: center;
    background: #edeff2;
}
</style>
